import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// import { RadioGroup, Radio } from '@material-ui/core';
import {
  RadioGroup,
  Radio,
  Select,
  FormControl,
  Input,
  InputLabel,
  ListItemText
} from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButtonShop from '../../components/atoms/CancelButtonShop';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GochiMenuEditConfirmShop from './GochiMenuEditConfirmShop';
import {
  getGochiMenus,
  editGochiMenu,
  addGochiMenuImage
} from '../../actions/GochiMenus';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import ValidationText from '../../components/atoms/ValidationText';
import { languages, languageType } from '../../constants/Language';
// import listMenuChildTypes from '../../constants/MenuChildType';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = theme => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 20
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  textField: {
    padding: '0px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px',
    width: '100%'
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  listForm: {
    display: 'block'
  },
  itemForm: {
    display: 'block',
    padding: '20px 20px 12px',
    borderBottom: '1px solid #DDDDDD'
  },
  textExplain: {
    fontSize: 12
  },
  btnBtom: {
    padding: '0 12px 10px 12px'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  displayFlex: {
    display: 'flex',
    alignItems: 'end'
    // [theme.breakpoints.down('sm')]: {
    //   display: 'flex',
    //   border: 0,
    //   paddingTop: 0
    // }
  },
  displayFlexPulldown: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%'
  },
  displayBlock: {
    display: 'block'
  },
  textYen: {
    width: '30px',
    paddingBottom: 4
  },
  textMutiple: {
    // width: '52px',
    fontWeight: 'bold',
    fontSize: 19,
    paddingLeft: 10,
    paddingRight: 10
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  divisionLabel: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.38)',
    marginTop: 16
  },
  situationPulldown: {
    width: '100%',
    margin: '16px 0px 8px'
  },
  pulldownHeight: {
    maxHeight: '350px'
  },
  fukuokaTextPrice: {
    color: '#F50057',
    fontSize: '14px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          editGochiMenu,
          addGochiMenuImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 1),
  withState('comboMenu', 'setComboMenu', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('price', 'setPrice', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscription', 'setSubscription', 0),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expirationType', 'setExpirationType', 0),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 0; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 1; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    defaultPrice: props => () => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;
      // TODO DBから取得
      let tax = 0.1;
      if (props.editInput.reducedTaxCheck) {
        tax = 0.08;
      }

      if (props.editInput.price !== '') {
        if (props.editInput.taxType === 'INTERNAL') {
          const amountTemp = parseFloat(
            (props.editInput.price / (1 + tax)).toFixed(9)
          );
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price - taxAmount;
        } else if (props.editInput.taxType === 'DONATION') {
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price;
        } else {
          includedTaxPrice =
            props.editInput.price + Math.round(props.editInput.price * tax);
          excludedTaxPrice = props.editInput.price;
        }
      }
      // props.setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log(excludedTaxPrice);
      const priceShow = includedTaxPrice
        ? parseInt(includedTaxPrice, 0).toString()
        : '0';
      props.setPriceCalc(`${priceShow} (税込み)`);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setMenuChildType(this.props.editInput.menuChildType);
      this.props.setGroupId(this.props.editInput.groupId);
      this.props.setGroupName(this.props.editInput.groupName);
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setShopName(this.props.editInput.shopName);
      this.props.setMenuId(this.props.editInput.menuId);
      this.props.setMenuName(this.props.editInput.menuName);
      this.props.setPrice(this.props.editInput.price);
      this.props.setComboMenu(this.props.editInput.comboMenu);
      this.props.setMenuLimitTotal(this.props.editInput.menuLimitTotal || 0);
      this.props.setSubscription(this.props.editInput.subscription);
      this.props.setSubscriptionIntervalCount(
        this.props.editInput.subscriptionIntervalCount
      );
      this.props.setSubscriptionInterval(
        this.props.editInput.subscriptionInterval
      );
      this.props.setPriceCombo(this.props.editInput.priceCombo);
      this.props.setQuantityRelease(this.props.editInput.quantityRelease);
      this.props.setQuantityPromotion(this.props.editInput.quantityPromotion);
      this.props.setPromotionDescription(
        this.props.editInput.promotionDescription
      );
      this.props.setUsageLimit(this.props.editInput.usageLimit);
      this.props.setExpiration(this.props.editInput.expiration);
      if (this.props.editInput.expirationEndDate) {
        this.props.setExpirationType(1);
      } else if (this.props.editInput.expiration) {
        this.props.setExpirationType(0);
      } else {
        this.props.setExpirationType(2);
      }
      this.props.setExpirationEndDate(this.props.editInput.expirationEndDate);
      this.props.setDescription(this.props.editInput.description);
      this.props.setTaxType(this.props.editInput.taxType);
      this.props.setReducedTaxType(this.props.editInput.reducedTaxType);
      if (this.props.editInput.reducedTaxType === 'REDUCED') {
        this.props.setReducedTaxCheck(true);
      }
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      this.props.setPreviewImage(this.props.editInput.image);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.defaultPrice();
      if (this.props.editInput.menuGenreId) {
        this.props.setMenuGenreId(this.props.editInput.menuGenreId.toString());
      } else {
        this.props.setMenuGenreId(null);
      }

      if (
        this.props.editInput.menuSituationIds &&
        this.props.editInput.menuSituationIds.length
      ) {
        this.props.setmenuSituationIds(
          this.props.editInput.menuSituationIds.map(String)
        );
      } else {
        this.props.setmenuSituationIds([]);
      }

      if (
        this.props.editInput.menuUserTargetIds &&
        this.props.editInput.menuUserTargetIds.length
      ) {
        this.props.setmenuUserTargetIds(
          this.props.editInput.menuUserTargetIds.map(String)
        );
      } else {
        this.props.setmenuUserTargetIds([]);
      }

      let dataFirst = {};
      const origilData = {
        menuChildType: null,
        groupId: null,
        shopId: null,
        menuName: null,
        price: null,
        description: null,
        menuCombo: null,
        menuLimitTotal: null,
        priceCombo: null,
        quantity: null,
        quantityFree: null,
        quantityFreeDes: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        numberUsePerDay: null,
        expiration: null,
        expirationEndDate: null,
        taxType: null,
        reducedTaxType: null,
        tags: null,
        tagStr: null,
        updatedAt: null,
        groupName: null,
        shopName: null,
        menuGenreId: null,
        menuGenreName: null,
        menuSituationIds: [],
        menuSituationNames: null,
        menuUserTargetIds: [],
        menuUserTargetNames: null
      };
      dataFirst = origilData;
      if (this.props.editInput.otherLanguages) {
        const str = JSON.stringify(this.props.editInput.otherLanguages);
        dataFirst.otherLanguages = JSON.parse(str);
      }
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) return;
        const translatedData = dataFirst.otherLanguages.find(
          el => el.language === item.value
        );
        if (!translatedData) {
          const other = {
            translateType: 0,
            language: item.value
          };
          dataFirst.otherLanguages.push(other);
        }
      });
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    roles,
    editInput,
    openEditConfirm,
    updateOpenEdit,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    menuChildType,
    groupId,
    groupName,
    shopId,
    shopName,
    menuId,
    menuName,
    setMenuName,
    comboMenu,
    menuLimitTotal,
    subscripIntervalCountError,
    setSubscripIntervalCountError,
    // setComboMenu,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    quantityReleaseList,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    usageLimit,
    setUsageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expirationType,
    setExpirationType,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    setExpirationEndDate,
    minExpirationDate,
    maxExpirationDate,
    expirationList,
    subscriptionInterval,
    setSubscriptionInterval,
    subscriptionIntervalCount,
    setSubscriptionIntervalCount,
    subscription,
    setSubscription,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    updatedAt,
    reducedTaxMenuPrefix,
    menuNameError,
    setMenuNameError,
    priceError,
    setPriceError,
    handleChangePage,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreError,
    setMenuGenreError,
    isFukuoka
  }) => {
    const errors = {
      menuNameError,
      priceError,
      priceComboError,
      quantityReleaseError,
      quantityPromotionError,
      subscripIntervalCountError,
      expirationError,
      menuGenreError
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType,
        groupId,
        shopId,
        menuName,
        price,
        description,
        menuCombo: comboMenu,
        menuLimitTotal: comboMenu === 0 ? menuLimitTotal : undefined,
        priceCombo,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expiration,
        expirationEndDate,
        taxType,
        reducedTaxType,
        tags,
        tagStr,
        updatedAt,
        shopName,
        groupName,
        menuGenreId,
        menuSituationIds,
        menuUserTargetIds
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    // setting language
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setMenuName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuName
                ? multiLangData.otherLanguages[k].params.menuName
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
            setPromotionDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.quantityFreeDes
                ? multiLangData.otherLanguages[k].params.quantityFreeDes
                : ''
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setMenuName(multiLangData.menuName);
        setDescription(multiLangData.description);
        setPromotionDescription(multiLangData.quantityFreeDes);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    const validMenuName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };
    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        setMenuGenreError('必須項目です。');
        return 1;
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };
    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };
    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };
    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };
    const validSubscriptionIntervalCount = () => {
      const checkSubscription = subscription;
      if (checkSubscription === 1) {
        const valueIntervalCount = subscriptionIntervalCount;
        const valueInterval = subscriptionInterval;
        if (valueIntervalCount === '') {
          setSubscripIntervalCountError('必須項目です。');
          return 1;
        }
        if (Number(valueIntervalCount) < 1) {
          setSubscripIntervalCountError('頻度価値は1以上ご入力ください');
          return 1;
        }
        if (!/^\d+$/.test(valueIntervalCount)) {
          setSubscripIntervalCountError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueInterval === 'WEEK' && Number(valueIntervalCount) > 52) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
        if (valueInterval === 'MONTH' && Number(valueIntervalCount) > 12) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
      }
      setSubscripIntervalCountError('');
      return 0;
    };
    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '' || !value) {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };
    const validExpiration = () => {
      const value = expiration;
      if (value === '' || !value) {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      // Menu normal
      if (comboMenu === 0) {
        errorCount =
          validSubscriptionIntervalCount() +
          validMenuName() +
          validPrice() +
          validMenuGenre();
      } else if (comboMenu === 1) {
        // Menu combo
        errorCount =
          validMenuName() +
          // validPrice() +
          validPriceCombo() +
          validQuantityRelease() +
          validSubscriptionIntervalCount() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre();
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const getSituationName = () => {
      const situationName = [];
      if (menuSituationIds.length) {
        menuSituationIds.forEach(id => {
          const name = menuSituation.find(
            situation => situation.menuSituationId.toString() === id.toString()
          ).menuSituationName;
          situationName.push(name);
        });
        return situationName.join(', ');
      }
      return '';
    };

    console.log('listtarget', menuUserTarget);
    console.log('menuUserTargetIds', menuUserTargetIds);

    const getUserTargetName = () => {
      const userTargetName = [];
      if (menuUserTargetIds.length) {
        menuUserTargetIds.forEach(id => {
          const names = menuUserTarget.find(
            userTarget =>
              userTarget.menuUserTargetId.toString() === id.toString()
          ).name;
          userTargetName.push(names);
        });
        return userTargetName.join(', ');
      }
      return '';
    };

    const cancelAction = () => updateOpenEdit(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMenuSituationNames(getSituationName());
        setMenuUserTargetNames(getUserTargetName());
        setMultiLangData(getCurrentData());
        updateOpenEditConfirm(true);
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const editedMenu = await actions
        .editGochiMenu(menuId, multiLangData)
        .then(data => checkSession(data));
      if (typeof image !== 'undefined' && image !== null) {
        let imageData = image;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile('menu', menuId, imageData, 'public');
        actions
          .addGochiMenuImage(menuId, {
            image: imagePath
          })
          .then(data => checkSession(data));
      }
      if (editedMenu.type === 'EDIT_GOCHI_MENU_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getGochiMenus(searchKey).then(data => checkSession(data));
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        setResultMessage('編集に失敗しました。');
        updateLoading(false);
      }
    };
    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEdit(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
        handleChangePage(null, 1, 10);
      } else {
        updateOpenEditProgress(false);
      }
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }

      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log(excludedTaxPrice);
      const val =
        e.target.id !== 'reducedTax' && typeof e.target.id !== 'undefined'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };
    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };
    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6" className={classes.titleDetail}>
            {isFukuoka ? 'コース情報編集' : 'メニュー編集'}
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <List component="nav" className={classes.listForm}>
            {
              <>
                <ListItem className={classes.itemForm}>
                  <Select
                    className={classes.textField}
                    value={isLanguage}
                    onChange={e => {
                      if (isLanguage === e.target.value) {
                        return;
                      }
                      if (
                        valid() ||
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0)
                      ) {
                        setLanguage(e.target.value);
                      } else {
                        alert('登録情報を正しく入力してください。');
                      }
                    }}
                  >
                    {languages.map(lang => (
                      <MenuItem key={lang.value} value={lang.value}>
                        {lang.label}
                      </MenuItem>
                    ))}
                  </Select>
                </ListItem>
                {isLanguage !== languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography component="div" className={classes.formInput}>
                      <RadioGroup
                        value={translateType}
                        onChange={e => {
                          setTranslateType(parseInt(e.target.value, 10));
                        }}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="GG翻訳を選択"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="自分で文章入力"
                        />
                      </RadioGroup>
                    </Typography>
                  </ListItem>
                )}
              </>
            }
            {parseInt(editInput.menuChildType, 10) !== 3 &&
              parseInt(editInput.menuChildType, 10) !== 4 &&
              !isFukuoka &&
              isLanguage === languageType.ORIGIN && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      required
                      label="店舗名"
                      defaultValue={editInput.shopName}
                      className={classes.textField}
                      margin="normal"
                      InputProps={{
                        readOnly: true
                      }}
                      variant="filled"
                    />
                  </Typography>
                </ListItem>
              )}
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <RequiredButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  required
                  label={isFukuoka ? 'コース名' : 'メニュー名'}
                  defaultValue={editInput.menuName}
                  className={classes.textField}
                  margin="normal"
                  value={menuName}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  onChange={e => {
                    setMenuName(e.target.value);
                  }}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 100 : 250
                  }}
                  onBlur={validMenuName}
                />
                {(isLanguage === languageType.ORIGIN ||
                  translateType === 1) && (
                  <ValidationText message={errors.menuNameError} />
                )}
              </Typography>
            </ListItem>
            {isLanguage === languageType.ORIGIN && !isFukuoka && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    区分
                  </Typography>
                  <RadioGroup value={editInput.comboMenu}>
                    <FormControlLabel
                      disabled
                      value={editInput.comboMenu}
                      control={<Radio color="primary" />}
                      label={editInput.comboMenu === 1 ? '回数券' : '普通'}
                    />
                  </RadioGroup>
                </Typography>
              </ListItem>
            )}
            {comboMenu === 0 &&
              isLanguage === languageType.ORIGIN &&
              !isFukuoka && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <Typography className={classes.divisionLabel}>
                      利用方法
                    </Typography>
                    <RadioGroup row value={menuLimitTotal}>
                      <FormControlLabel
                        value={0}
                        disabled
                        control={<Radio color="primary" />}
                        label="一枚単位利用"
                      />
                      <FormControlLabel
                        value={1}
                        disabled
                        control={<Radio color="primary" />}
                        label="一円単位利用"
                      />
                    </RadioGroup>
                  </Typography>
                </ListItem>
              )}
            {enabledStripeBilling === true && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    サブスクチケット利用する
                  </Typography>
                  <RadioGroup
                    row
                    value={subscription}
                    onChange={e => {
                      setSubscription(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      disabled
                      value={1}
                      control={<Radio color="primary" />}
                      label="利用する"
                    />
                    <FormControlLabel
                      disabled
                      value={0}
                      control={<Radio color="primary" />}
                      label="利用しない"
                    />
                  </RadioGroup>
                </Typography>
              </ListItem>
            )}
            {subscription === 1 && enabledStripeBilling === true && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    購入頻度設定
                  </Typography>
                  <div className={classes.displayFlex}>
                    <div className={classes.displayFlex}>
                      <TextField
                        id="subscriptionIntervalCount"
                        required
                        disabled
                        label="頻度"
                        className={classes.textFieldPriceCombo}
                        margin="normal"
                        value={subscriptionIntervalCount}
                        onChange={e => {
                          setSubscriptionIntervalCount(e.target.value.trim());
                        }}
                        onBlur={validSubscriptionIntervalCount}
                      />
                    </div>
                    <div className={classes.displayFlexPulldown}>
                      <TextField
                        id="subscriptionInterval"
                        name="subscriptionInterval"
                        select
                        required
                        disabled
                        label="単位"
                        className={classes.textFieldPriceCombo}
                        margin="normal"
                        value={subscriptionInterval}
                        InputProps={{
                          shrink: true
                        }}
                        onChange={e => {
                          setSubscriptionInterval(e.target.value.trim());
                        }}
                      >
                        <MenuItem key="0" value="WEEK">
                          週間
                        </MenuItem>
                        <MenuItem key="1" value="MONTH">
                          ヶ月
                        </MenuItem>
                      </TextField>
                      <div className={classes.textYen}>1回</div>
                    </div>
                  </div>
                  <div className={classes.displayBlock}>
                    <ValidationText
                      message={errors.subscripIntervalCountError}
                    />
                  </div>
                </Typography>
              </ListItem>
            )}
            {editInput.comboMenu === 1 && (
              <>
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <RequiredButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <Typography className={classes.divisionLabel}>
                        単価×発行枚数
                      </Typography>
                      <div className={classes.displayFlex}>
                        <div className={classes.displayFlex}>
                          <TextField
                            id="priceCombo"
                            required
                            label="単価"
                            defaultValue={editInput.priceCombo}
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={priceCombo}
                            onChange={e => {
                              setPriceCombo(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validPriceCombo}
                          />
                        </div>
                        <div className={classes.textYen}>円</div>
                        <div className={classes.textMutiple}>×</div>
                        <div className={classes.displayFlexPulldown}>
                          <TextField
                            id="quantityRelease"
                            name="quantityRelease"
                            select
                            required
                            label="発行枚数"
                            defaultValue={editInput.quantityRelease}
                            className={classes.textFieldPriceCombo}
                            InputProps={{
                              shrink: true
                            }}
                            margin="normal"
                            value={quantityRelease}
                            onChange={e => {
                              setQuantityRelease(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validQuantityRelease}
                          >
                            {quantityReleaseList.map(item => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </div>
                        <div className={classes.textYen}>枚</div>
                      </div>
                      <div className={classes.displayBlock}>
                        <ValidationText message={errors.priceComboError} />
                        <ValidationText message={errors.quantityReleaseError} />
                      </div>
                    </Typography>
                  </ListItem>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        id="quantityPromotion"
                        name="quantityPromotion"
                        select
                        label="付与無料枚数"
                        defaultValue={editInput.quantityPromotion}
                        className={classes.textFieldLong}
                        margin="normal"
                        value={quantityPromotion}
                        InputProps={{
                          shrink: true
                        }}
                        onChange={e => {
                          setQuantityPromotion(e.target.value);
                        }}
                        onBlur={validQuantityPromotion}
                      >
                        {quantityReleaseList.map(item => {
                          return (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                      <ValidationText message={errors.quantityPromotionError} />
                    </Typography>
                  </ListItem>
                )}
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <AnyButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      label="おまけ"
                      defaultValue={editInput.promotionDescription}
                      // multiline
                      // rows="3"
                      className={classes.textFieldLong}
                      margin="normal"
                      value={promotionDescription}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 1000 : 2500
                      }}
                      onChange={e => {
                        setPromotionDescription(e.target.value);
                      }}
                    />
                  </Typography>
                </ListItem>
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography
                      component="div"
                      className={classes.divisionLabel}
                    >
                      利用制限
                    </Typography>
                    <RadioGroup
                      row
                      defaultValue={editInput.usageLimit}
                      value={usageLimit}
                      onChange={e => {
                        setUsageLimit(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="1日1枚"
                      />
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="なし"
                      />
                    </RadioGroup>
                  </ListItem>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography
                      component="div"
                      className={classes.divisionLabel}
                    >
                      利用期間
                    </Typography>
                    <RadioGroup
                      col
                      value={expirationType}
                      onChange={e => {
                        setExpirationType(parseInt(e.target.value, 10));
                        resetExpirationValue();
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="期間指定"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="期限指定"
                      />
                      <FormControlLabel
                        value={2}
                        control={<Radio color="primary" />}
                        label="指定しない"
                      />
                    </RadioGroup>
                    {expirationType === 0 && (
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          select
                          label="利用期間"
                          className={classes.textFieldLong}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          defaultValue={editInput.expiration}
                          value={expiration}
                          onChange={e => {
                            setExpiration(e.target.value);
                          }}
                          // onBlur={validExpiration}
                        >
                          {expirationList.map(item => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                        <ValidationText message={errors.expirationError} />
                      </Typography>
                    )}
                    {expirationType === 1 && (
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          label="終了"
                          type="date"
                          className={classes.textFieldLong}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          defaultValue={editInput.expirationEndDate}
                          value={expirationEndDate}
                          inputProps={{
                            min: minExpirationDate,
                            max: maxExpirationDate
                          }}
                          onChange={e => {
                            setExpirationEndDate(e.target.value);
                          }}
                        />
                      </Typography>
                    )}
                  </ListItem>
                )}
                {/* <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <AnyButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      label="利用期間"
                      defaultValue={editInput.expiration}
                      className={classes.textFieldLong}
                      margin="normal"
                      value={expiration}
                      onChange={e => {
                        setExpiration(e.target.value);
                      }}
                      onBlur={validExpiration}
                    />
                    <ValidationText message={errors.expirationError} />
                  </Typography>
                </ListItem> */}
              </>
            )}
            {isLanguage === languageType.ORIGIN && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <TextField
                    id="price"
                    required
                    disabled={editInput.comboMenu === 1}
                    label={isFukuoka ? '金額' : '価格'}
                    defaultValue={editInput.price}
                    className={classes.textField}
                    margin="normal"
                    value={price}
                    onChange={e => {
                      setPrice(e.target.value.trim());
                      calcPrice(e);
                    }}
                    onBlur={validPrice}
                  />
                  <ValidationText message={errors.priceError} />
                  <div className={classes.priceCalc}>{priceCalc}</div>
                  {isFukuoka && (
                    <div className={classes.fukuokaTextPrice}>
                      ※10,000円以内の金額を入力してください
                    </div>
                  )}
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <div>
                    <TextField
                      id="taxType"
                      name="taxType"
                      select
                      label={isFukuoka ? '税区分' : '税区分・寄付'}
                      className={classes.textField}
                      margin="normal"
                      value={taxType}
                      onChange={e => {
                        setTaxType(e.target.value.trim());
                        calcPrice(e);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    >
                      {isFukuoka
                        ? taxTypes
                            .filter(group => {
                              return group.id !== 'DONATION';
                            })
                            .map(group => {
                              return (
                                <MenuItem key={group.id} value={group.id}>
                                  {group.name}
                                </MenuItem>
                              );
                            })
                        : taxTypes.map(group => {
                            return (
                              <MenuItem key={group.id} value={group.id}>
                                {group.name}
                              </MenuItem>
                            );
                          })}
                    </TextField>
                  </div>
                  {!isFukuoka && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          id="reducedTax"
                          checked={reducedTaxCheck}
                        />
                      }
                      checked={reducedTaxCheck}
                      label="軽減税率対象"
                      onChange={e => {
                        setReducedTaxCheck(e.target.checked);
                        convertReducedTax(e.target.checked);
                        calcPrice(e);
                      }}
                    />
                  )}
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && !isFukuoka && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <TextField
                    required
                    select
                    label="ジャンル"
                    className={classes.textField}
                    margin="normal"
                    value={menuGenreId}
                    onChange={e => {
                      setMenuGenreId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={validMenuGenre}
                  >
                    {menuGenre &&
                      menuGenre.map(item => {
                        return (
                          <MenuItem
                            key={item.menuGenreId}
                            value={item.menuGenreId}
                          >
                            {item.menuGenreName}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                  <ValidationText message={errors.menuGenreError} />
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && !isFukuoka && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <AnyButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <FormControl className={classes.situationPulldown}>
                    <InputLabel id="situation-label">
                      シチュエーション
                    </InputLabel>
                    <Select
                      labelId="situation-label"
                      multiple
                      value={menuSituationIds}
                      onChange={e => setmenuSituationIds(e.target.value)}
                      input={<Input />}
                      renderValue={() => getSituationName()}
                      className={classes.textFieldLong}
                      MenuProps={{
                        classes: { paper: classes.pulldownHeight },
                        getContentAnchorEl: null
                      }}
                    >
                      {menuSituation &&
                        menuSituation.map(situation => (
                          <MenuItem
                            key={situation.menuSituationId}
                            value={situation.menuSituationId}
                          >
                            <Checkbox
                              checked={
                                menuSituationIds.indexOf(
                                  situation.menuSituationId
                                ) > -1
                              }
                            />
                            <ListItemText
                              primary={situation.menuSituationName}
                            />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && !isFukuoka && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <AnyButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <FormControl className={classes.situationPulldown}>
                    <InputLabel id="user-target-label">贈り相手</InputLabel>
                    <Select
                      labelId="user-target-label"
                      multiple
                      value={menuUserTargetIds}
                      onChange={e => setmenuUserTargetIds(e.target.value)}
                      input={<Input />}
                      renderValue={() => getUserTargetName()}
                      className={classes.textFieldLong}
                      MenuProps={{
                        classes: { paper: classes.pulldownHeight },
                        getContentAnchorEl: null
                      }}
                    >
                      {menuUserTarget &&
                        menuUserTarget.map(target => (
                          <MenuItem
                            key={target.menuUserTargetId}
                            value={target.menuUserTargetId}
                          >
                            <Checkbox
                              checked={
                                menuUserTargetIds.indexOf(
                                  target.menuUserTargetId
                                ) > -1
                              }
                            />
                            <ListItemText primary={target.name} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Typography>
              </ListItem>
            )}
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <AnyButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  label="説明"
                  multiline
                  rows="4"
                  defaultValue={editInput.description}
                  className={classes.textFieldLong}
                  margin="normal"
                  value={description}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 1000 : 2500
                  }}
                  onChange={e => {
                    setDescription(e.target.value);
                  }}
                />
              </Typography>
            </ListItem>
            {isLanguage === languageType.ORIGIN && !isFukuoka && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <AnyButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <TextField
                    label="タグ"
                    defaultValue={editInput.tagStr}
                    className={classes.textFieldLong}
                    margin="normal"
                    value={tagStr}
                    onChange={e => {
                      setTagStr(e.target.value);
                      splitTagStr(e.target.value);
                    }}
                  />
                </Typography>
                <Typography component="div" className={classes.textExplain}>
                  #おすすめ #おふくろの味 #学生に ＃ガッツリ
                  などメニューの特徴を表すタグを記載できます。
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <AnyButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <FileUpload
                    label="image"
                    file={image}
                    setFile={setImage}
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                  />
                  <div className={classes.textExplain}>
                    ※8MB以内でお願いします。
                  </div>
                </Typography>
              </ListItem>
            )}
          </List>
        </Paper>
        <div className={classes.btnBtom}>
          <CancelButtonShop onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm} className={classes.modalMobile}>
          <GochiMenuEditConfirmShop
            backAction={backAction}
            editAction={editAction}
            editConfirm={multiLangData}
            roles={roles}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            currentLanguage={isLanguage}
            previewImage={previewImage}
            menuGenreName={menuGenreName}
            menuSituationNames={menuSituationNames}
            menuUserTargetNames={menuUserTargetNames}
            isFukuoka={isFukuoka}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
